import React from "react";

const NotificationTemplate = React.lazy(() => import("./index"));
const CreateNotificationTemplate = React.lazy(() =>
  import("./CreateNotificationTemplate")
);
const NotificationTemplateDetails = React.lazy(() =>
  import("./NotificationTemplateDetails")
);

export const NotificationTemplateRoutes = [
  {
    path: "/admin/notificationTemplate",
    name: "Notification Template",
    element: <NotificationTemplate />,
  },
  {
    path: "/admin/notificationTemplate/create",
    name: "Create Notification Template",
    element: <CreateNotificationTemplate />,
  },
  {
    path: "/admin/notificationTemplate/update/:id?",
    name: "Create Notification Template",
    element: <CreateNotificationTemplate />,
  },
  {
    path: "/admin/notificationTemplates/:id?",
    name: "Notification Template Details",
    element: <NotificationTemplateDetails />,
  },
];
